import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { EarlyAccessForm } from '../components/EarlyAccessForm';
import { ServicesPreview } from '../components/ServicesPreview';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { WhyJoinEarly } from '../components/WhyJoinEarly';
import { DevelopmentNotice } from '../components/DevelopmentNotice';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function ComingSoon() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-243">
      <Header data-id="element-244" />
      <main data-id="element-245">
        <Hero data-id="element-246" />
        <EarlyAccessForm data-id="element-247" />
        <ServicesPreview data-id="element-248" />
        <WhoItIsFor data-id="element-249" />
        <WhyJoinEarly data-id="element-250" />
        <DevelopmentNotice data-id="element-251" />
        <ContactForm data-id="element-252" />
      </main>
      <Footer data-id="element-253" />
    </div>;
}